var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"00622d30e7166ea6de85cb5e7f19c31ae7d52e58"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tryup-hp@pluspace"]={id:"00622d30e7166ea6de85cb5e7f19c31ae7d52e58"};
      